// project routes
const GroupManagement = () => import('@/views/project/groupManagement/index.vue');
const ProjectManagement = () => import('@/views/project/projectManagement/index.vue');
const ProjectMonthlyReport = () => import('@/views/project/monthlyReport/index.vue');
const ProjectPerCapitaDataReport = () => import('@/views/project/report/perCapitaData.vue');
const ProjectPerCapitaSummaryReport = () => import('@/views/project/report/perCapitaSummary.vue');
const ProjectEfficiencyDataReport = () =>
  import('@/views/project/report/projectEfficiencyData.vue');
const ProjectEfficiencySummaryReport = () =>
  import('@/views/project/report/projectEfficiencySummary.vue');

export default [
  {
    path: '/project/groupManagement',
    name: 'groupManagement',
    meta: {
      title: '小组管理',
      icon: 'el-icon-s-custom',
      path: '项目管理',
      noCache: true,
      affix: true
    },
    component: GroupManagement
  },
  {
    path: '/project/projectManagement',
    name: 'projectManagement',
    meta: {
      title: '项目信息',
      icon: 'el-icon-s-order',
      path: '项目管理',
      noCache: true,
      affix: true
    },
    component: ProjectManagement
  },
  {
    path: '/project/monthlyReport',
    name: 'projectMonthlyReport',
    meta: {
      title: '项目进度',
      icon: 'el-icon-date',
      path: '项目管理',
      noCache: true,
      affix: true
    },
    component: ProjectMonthlyReport
  },
  {
    path: '/project/report/perCapitaData',
    name: 'projectPerCapitaDataReport',
    meta: {
      title: '项目收入统计',
      icon: 'el-icon-data-analysis',
      path: '项目管理',
      noCache: true,
      affix: true
    },
    component: ProjectPerCapitaDataReport
  },
  {
    path: '/project/report/perCapitaSummary',
    name: 'projectPerCapitaSummaryReport',
    meta: {
      title: '人均效能汇总',
      icon: 'el-icon-data-analysis',
      path: '项目管理',
      noCache: true,
      affix: true
    },
    component: ProjectPerCapitaSummaryReport
  },
  {
    path: '/project/report/projectEfficiencyData',
    name: 'projectEfficiencyDataReport',
    meta: {
      title: '项目执行统计',
      icon: 'el-icon-pie-chart',
      path: '项目管理',
      noCache: true,
      affix: true
    },
    component: ProjectEfficiencyDataReport
  },
  {
    path: '/project/report/projectEfficiencySummary',
    name: 'projectEfficiencySummaryReport',
    meta: {
      title: '项目分析预警',
      icon: 'el-icon-pie-chart',
      path: '项目管理',
      noCache: true,
      affix: true
    },
    component: ProjectEfficiencySummaryReport
  }
];
